import { render, staticRenderFns } from "./BaseCartaoPonto.vue?vue&type=template&id=eddefb9a"
import script from "./BaseCartaoPonto.vue?vue&type=script&lang=js"
export * from "./BaseCartaoPonto.vue?vue&type=script&lang=js"
import style0 from "./BaseCartaoPonto.vue?vue&type=style&index=0&id=eddefb9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports